import {gsap} from "../LibrariesImport";

export default class Follower {
	static init() {

		const followers = document.querySelectorAll('.follower');

		followers.forEach( (follower) => {

			const contentFollower = follower.closest('.content-follower');

			if( !contentFollower ){
				return;
			}

			const revealsFollower = contentFollower.querySelectorAll('.reveal-follower');
			revealsFollower.forEach((reveal) => {
				reveal.addEventListener("mouseenter", () => {
					gsap.to(follower, {
						scale: 1,
						opacity: 1,
						duration: 0.3
					});
				});
				reveal.addEventListener("mouseleave", () => {
					gsap.to(follower, {
						scale: 0,
						opacity: 0,
						duration: 0.3
					});
				});
			});

			const quickX = gsap.quickTo(follower, "x", {duration: 0.3, ease: "power2.out"});
			const quickY = gsap.quickTo(follower, "y", {duration: 0.3, ease: "power2.out"});
			const quickRotate = gsap.quickTo(follower, "rotation", {duration: 0.3, ease: "power2.out"});
			let lastX = 0, lastY = 0;

			contentFollower.addEventListener("mousemove", (event) => {
				const {left, top} = contentFollower.getBoundingClientRect(); // Position du parent
				const rect = follower.getBoundingClientRect(); // Taille du follower
				const offsetX = rect.width / 2;
				const offsetY = rect.height / 2;

				// Calcul des positions relatives
				const relativeX = event.clientX - left - offsetX;
				const relativeY = event.clientY - top - offsetY;

				// Calcul de l'angle de rotation en fonction du déplacement
				const deltaX = relativeX - lastX;
				// const deltaY = relativeY - lastY;
				const angle = deltaX * 0.9; // Ajuste la sensibilité de l'inclinaison

				// Mise à jour des valeurs stockées
				lastX = relativeX;
				lastY = relativeY;

				// Appliquer les animations
				quickX(relativeX);
				quickY(relativeY);
				quickRotate(angle); // Appliquer l'inclinaison
			});

		});

	}

}
